const data = {
  id: 1,
  title: 'Listen and choose two stressed words.',
  subTitle: 'Nghe và chọn hai từ được nhấn trọng âm trong câu.',
  question: 'What do you have?',
  answers: [
    { answer: 'What', isCorrect: true },
    { answer: 'do', isCorrect: false },
    { answer: 'have', isCorrect: true },
  ],
  // audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/80da860e-405d-4913-a452-d12a833bdbb8.mp3',
};

export default data;
